import { useEffect } from 'react'
import { LayoutTwoR } from '../../Layout/CommonStyle'
import { useAppDispatch } from '../../../store'
import { setMenuIndex } from '../../../store/userSlice'
import { MenteeMenu } from '../../../models/Enums'
import RecentJobs from '../../Common/RecentJobs'
import JobSearch from '../../Common/JobSearch'

function MenteeSearch() {
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(setMenuIndex(MenteeMenu.SEARCH))
  }, [])

  return (
    <LayoutTwoR>
      <JobSearch />
      <RecentJobs />
    </LayoutTwoR>
  )
}

export default MenteeSearch
